export class TestdafDigitalResultDto {
    bookingId: number;
    personId: number;
    eventId: number;
    teilnehmerNr: string;
    fullname: string;
    birthday: string;
    format: string;
    examDate: string;
    certificateDate: string;
    tdnLV: string;
    tdnHV: string;
    tdnMA: string;
    tdnSA: string;
    scoreLV: string;
    scoreHV: string;
    scoreMA: string;
    scoreSA: string;
    organizationName: string;
    verified: boolean;
}
